import styled from 'styled-components';

import { simpleFlex } from 'theme/tools';

export const Container = styled.div`
  ${simpleFlex};
  justify-content: center;
  height: 100%;
`;
